<section class="row items-container">
  <app-search-bar placeholder="Search items by name or category" (searchChange)="filterItems($event)"></app-search-bar>
  <div class="col col-12 toolbar-container" *ngIf="enableToolbar">
    <ion-toolbar>
      <section>
        <ion-title class="page-title p-0">
          <span [innerText]="items?.length"></span>
          <span class="mx-1" translate="FOOD_ITEMS"></span>
        </ion-title>
      </section>
      <section class="actions" slot="end" *ngIf="items?.length">
        <ion-button fill="outline" class="ion-text-capitalize" (click)="onNewClick()" translate="NEW_ITEM">
          <ion-icon slot="start" name="add-outline"></ion-icon>
        </ion-button>
      </section>
    </ion-toolbar>
  </div>

  <ion-card *ngFor="let item of items; let i = index"
    class="col col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 item-with-borders item">
    <div class="thumbnail" *ngIf="item.iconImage else elsePreview"
      [style.background-image]="'url(' + item.iconImage.url + ')'">
      <app-food-type-indicator [ngClass]="item.vegetarian ? 'veg' : 'non-veg'"></app-food-type-indicator>
    </div>
    <ng-template #elsePreview>
      <div class="thumbnail">
        <app-food-type-indicator [ngClass]="item.vegetarian ? 'veg' : 'non-veg'"></app-food-type-indicator>
      </div>
    </ng-template>

    <ion-card-header>
      <ion-card-title class="mt-2 pt-3" [innerText]="item.name"></ion-card-title>
      <ion-card-subtitle class="tags">
        <ion-icon name="pricetags-outline"></ion-icon>
        <span [innerText]="item.tags?.join(', ')"></span>
      </ion-card-subtitle>

      <section class="actions">
        <ion-button color="primary" fill="clear" title="Edit Item" (click)="onEditClick($event, item)">
          <ion-icon slot="icon-only" src="assets/icons/edit_24dp.svg"></ion-icon>
        </ion-button>
        <ion-button color="danger" fill="clear" title="Delete Item" (click)="onDeleteClick($event, item, i)">
          <ion-icon slot="icon-only" name="trash-outline" color="danger"></ion-icon>
        </ion-button>
      </section>
    </ion-card-header>
    <ion-card-content *ngIf="item.itemQuantity" class="quantity-info">
      <span class="" [innerText]="item?.itemQuantity.value"></span>
      <span class="" [innerText]="item?.itemQuantity.measurementUnit"></span>
    </ion-card-content>
    <ion-card-content>
      <div class="description" [innerText]="item?.description"></div>
      <!-- <div class="dashboard">Testing..</div> -->
    </ion-card-content>
  </ion-card>

  <ng-container *ngIf="!items?.length">
    <ion-list class="no-data-section">
      <ion-item lines="none" class="ion-text-center">
        <ion-label>No Items to Display!</ion-label>
      </ion-item>
      <ion-item lines="none" class="ion-text-center action">
        <ion-label>
          <ion-button class="ion-text-capitalize" fill="clear" size="small" (click)="onNewClick()">
            Add New Food Item
          </ion-button>
        </ion-label>
      </ion-item>
    </ion-list>
  </ng-container>
</section>
